import { Component, OnInit, AfterViewInit, EventEmitter, Input, Output, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';

// parent component
import { ModalBaseComponent } from '../modal-base/modal-base.component';
// models
import { AppState } from '../../../../booking/models/app-state.interface';
// ngrx store
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { Subscription } from 'rxjs';
// services
import { ErrorHandler } from '../../../services/error-handler.service';
import { CopyService } from '../../../services/app-copy.service';

declare var exponea: any;
@Component({
  selector: 'app-modal-product-type',
  templateUrl: './modal-product-type.component.html',
  styleUrls: ['./modal-product-type.component.scss']
})
export class ModalProductTypeComponent extends ModalBaseComponent implements OnInit, AfterViewInit {

  @Input()
  modalData;

  @Input()
  com;

  @Input()
  searchByFlightNumber;

  @Input()
  isSessionScreen;

  @Output()
  confirmFlightProductType: EventEmitter<any> = new EventEmitter;

  private _copyInitSubscription: Subscription;
  private _userLanguageSubscription: Subscription;

  public flightData;
  public bookingtData;
  public flightDetails;
  public isMultiLegFlight = false;
  public flightAvailability: any;
  public sessionServiceType: string;
  public selectedProductType: string;

  public copyLoaded: Boolean = false;
  public appCopy;
  public selectedLanguage = '';
  public productAvailability = null;
  public departurePrice = '';
  public arrivalPrice = '';
  public d2dPrice = '';

  public d2dNotAvailable: boolean = false;

  constructor(
    public _appStore: Store<AppState>,
    public errorService: ErrorHandler,
    public router: Router,
    private _copyService: CopyService,
    @Inject(PLATFORM_ID) public platformId: Object
  ) {
    super(_appStore, errorService, router, platformId);
  }

  ngOnInit() {

    console.log("modalData", this.modalData, this.com);

    window.scroll(0, 0);

    this.productAvailability = this.modalData.res.productAvailability;
    this.departurePrice = this.modalData.priceData.departurePrice;
    this.arrivalPrice = this.modalData.priceData.arrivalPrice;
    this.d2dPrice = this.modalData.priceData.d2dPrice;


    // will work without reloading
    this._copyInitSubscription = this._appStore.select('loadedStatusReducer')
      .subscribe((res: any) => {
        // if booking data has bookingLoaded
        // show template and subscribe to data

        this.copyLoaded = res.copyLoaded;
        if (res.copyLoaded) {
          if (isPlatformBrowser(this.platformId)) {
            this.getCopy();
          }
        }
        this._userLanguageSubscription = this._appStore.select('copyReducer')
          .subscribe((res: any) => {
            this.selectedLanguage = res.language
          })

      });

    const currentState = this.getState(this._appStore);
    this.sessionServiceType = this.getState(this._appStore).d2dReducer.sessionServiceType;
    this.selectedProductType = this.getState(this._appStore).flightFinderReducer.selectedProductType;

    if (this.selectedProductType) {
      // dotCom
      let hideModal = false;

      // re-check eligibility of product selected from dotCom
      switch (this.selectedProductType) {
        case 'd2d': {
          hideModal =
            this.productAvailability.abcAvailable &&
            this.productAvailability.ccdAvailable;

          this.d2dNotAvailable = !hideModal;
          break;
        }
        case 'abc': {
          hideModal = this.productAvailability.abcAvailable;
          break;
        }
        case 'ccd': {
          hideModal = this.productAvailability.ccdAvailable;
          break;
        }
        default: {
          hideModal = false;
          break;
        }
      }

      if (hideModal) {
        this.passProductType(this.selectedProductType);
        this._appStore.dispatch({
          type: 'UPDATE_REDIRECT_TO_SEARCH',
          payload: true,
        });
      }
    } else if (this.sessionServiceType) {
      // dataLink
      this.passProductType(this.sessionServiceType);
      this._appStore.dispatch({ type: 'UPDATE_REDIRECT_TO_SEARCH', payload: true });
    }

    if (this.modalData.multiLegData) {
      this.flightDetails = this.modalData.multiLegData.flightStatusDetails;
    } else {
      this.flightDetails = this.modalData.res.flightStatusDetails;
    }


    this.flightData = currentState.flightReducer;
    document.body.classList.add('model-bg');
  }

  getCopy() {
    const panelHeaderCopy = this._copyService.getCopyBySection(
      'OTHER',
      'results',
      ['panelHeader']
    );

    this.appCopy = {
      panelHeader: panelHeaderCopy[0],
    };

  }

  passProductType(v) {
    let productAvailability = JSON.parse(JSON.stringify(this.modalData.res.productAvailability));
    this._appStore.dispatch({ type: 'SELECTED_SERVICE_TYPE', payload: v });
    if (v === 'abc' && productAvailability.abcAvailable) {
      this.modalData.res.flightDirection = 1;
      this.modalData.res.productAvailability = {
        ...this.modalData.res.productAvailability,
        abcAvailable: true,
        ccdAvailable: false,
        journeyDirection: 1,
      };
    }

    if (v === 'ccd' && productAvailability.ccdAvailable) {
      this.modalData.res.flightDirection = 2;
      this.modalData.res.productAvailability = {
        ...this.modalData.res.productAvailability,
        abcAvailable: false,
        ccdAvailable: true,
        isDomesticABC: false,
        journeyDirection: 2,
      };

      // if (res.productAvailability.ccdAvailable) {
      //   const multiLegData_ = JSON.parse(JSON.stringify(multiLegData));
      //   res.flightDirection = 2;
      //   res.productAvailability = {
      //     ...res.productAvailability,
      //     abcAvailable: false,
      //     ccdAvailable: true,
      //     isDomesticABC: false,
      //     journeyDirection: 2,
      //   }

      //   if(multiLegData.totalNumberOfLegs > 1) {
      //     multiLegData_.flightInfo.requestFlightNumber = res.flightInfo.requestFlightNumber;
      //     multiLegData_.flightInfo.dateTimeAddedUTC = res.flightInfo.dateTimeAddedUTC;
      //     multiLegData_.flightInfo.requestedDateTime = res.flightInfo.requestedDateTime;
      //     // multiLegData_.flightStatusDetails = res.flightStatusDetails;
      //   }
      //   this.setFlightStoreItems(multiLegData_, res, hasFlightSession, isLinkedConnection);
      // } else {
      //   this.setFlightStoreItems(multiLegData, res, hasFlightSession, isLinkedConnection);
      // }

    }

    this._appStore.dispatch({ type: 'UPDATE_D2D_SERVICE', payload: false });

    if (v === 'd2d') {
      this.modalData.res.flightDirection = 1;
      this.modalData.res.productAvailability = {
        ...this.modalData.res.productAvailability,
        abcAvailable: true,
        ccdAvailable: false,
        journeyDirection: 1,
      };
      this._appStore.dispatch({ type: 'UPDATE_D2D_SERVICE', payload: false });
    }

    this.confirmFlightProductType.emit({ data: this.modalData, productAvailability, isTypeSelected: true, close: true })
    exponea.track('oldfunnel_productselect', {
      product_selected: v,
      abc_available: productAvailability.abcAvailable,
      ccd_available: productAvailability.ccdAvailable,
      d2d_available: productAvailability.abcAvailable && productAvailability.ccdAvailable,
      entry_source: this.getState(this._appStore).d2dReducer.entrySource || 'direct',
    });
  }

  close(event) {
    this.confirmFlightProductType.emit({ data: this.modalData, flightAvailability: '', close: true, isTypeSelected: false });
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }

  ngAfterViewInit(): void {
    const anchor = document.querySelector('.tooltiptext a');
    if (anchor) {
      console.log(anchor);
      anchor.addEventListener('click', function (e) {
        const linkEl = <HTMLAnchorElement>document.querySelector('.tooltiptext a');
        window.open(linkEl.href, 'blank');
      });
    }
  }

  ngOnDestroy() {
    this._copyInitSubscription.unsubscribe();
    if (this._userLanguageSubscription) { this._userLanguageSubscription.unsubscribe(); }
    document.body.classList.remove('model-bg');
    if (document.querySelector('.tooltiptext a')) { document.querySelector('.tooltiptext a').removeEventListener('click', () => { }); }
  }

}
